module.exports = __webpack_public_path__ + "static/media/Lileep_gaussian2.79713f58.png";